module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "fm-title"
  }, [_vm._v("INTRODUCTION")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“Everyone has been made for some particular work, and the desire for that work has been put in every heart.”")]), _vm._v(" "), _c('p', {
    staticClass: "author"
  }, [_vm._v("–Rumi")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "dropcap"
  }, [_vm._v("W")]), _vm._v("e’ve felt it. That dread of going back to work at an unsatisfying, unfulfilling job and leaving the kids behind for hours upon hours, only to come home, exhausted and cranky, and have to make dinner, tidy the house, and then be kept up at night by children and whatever germs they brought home from daycare that week.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("It’s not the working that’s the problem – we like to and want to work; it’s the job itself that doesn’t work anymore. It was fine before the kids, when there was a lot of downtime and we could recharge and relax during our off hours. There were ways to make it okay and, for a long time, it didn’t seem like nearly enough of a big deal to change things. The money was good. The vacation time was okay. The perks were lovely. There wasn’t much to complain about – except maybe the one tiny detail that it increasingly become a Soul-sucking, unhappy place to work.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Having a baby made going there harder. There was this cute face and fluffy bottom to say goodbye to each day and that got harder and harder to do, instead of easier and easier like we’d expected. We get rather attached to the drooling, smiling, poop factories of awesome that we call our kids, and the last thing we wanted to do was leave them behind to go do things that were… well, less than wonderful. Leaving them wasn’t fun, but we had to keep on going. Because money. And because sometimes we’re just not too sure what else we want to be doing instead.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Decisions get harder when exhaustion plays such a big role in life, and while we can see the benefits of making a career change, we’re not really sure how to pull it off. What if there’s more schooling involved? Or having to learn about starting a business? We can’t even fathom how to accomplish that "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("enormous")]), _vm._v(" feat on the small amount of energy and sleep we’re getting. A project that big definitely feels like something that should be saved for later… like maybe when the kids are married and have kids of their own.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Exhausted is the new normal. It’s not that the kids are especially difficult or that there’s anything we mind doing for them, but the relentlessness of each day, the interrupted sleep, the demands of each item on the to-do list, the unexpected things that pop up… well, it wears on a person. There’s not a lot of time or energy left over at the end of the day, it seems.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("And really, why rock the boat now? So we’re bored and miserable at work – what’s the big deal anyway? Lots of people are, after all. There are a few weeks vacation, some money, and you know exactly what you’re getting each day. There’s comfort in the familiarity. If it didn’t steal our Souls and make us weep with boredom to go to work and try and fit in with Charlie from accounting and Louise from purchasing, we’d love our jobs, really we would. Probably. Okay, maybe not.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("With such amazing perks, like being close enough to Starbucks to grab coffee a few times a day, and having a parking spot with our names on it, we really "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("should")]), _vm._v(" be okay working there. We "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("should")]), _vm._v(" take the steady, even road for the sake of the family. We "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("should")]), _vm._v(" love the security and comfort of going there each day and knowing what to expect. We "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("should")]), _vm._v(" want to keep a job that we worked so hard to get. We "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("should")]), _vm._v(" feel good each day instead of feeling irritable and ready to snap when we get home. We "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("should")]), _vm._v(" be in love with life and happy to live it each day. After all, we have what so many people want: a job, an awesome family, and a home to love.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Why ask for more?")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Because you can be grateful for it all – every single bit of it – and still want more"), _c('em', {
    staticClass: "italic"
  }, [_vm._v(".")])]), _vm._v(" "), _c('p', {
    staticClass: "indent-top"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("And that’s okay.")])]), _vm._v(" "), _c('p', {
    staticClass: "star"
  }, [_vm._v("* * *")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("There are costs to living an unsatisfying life and wanting each day to end, waiting for the weekend before we can begin to feel happy and satisfied, living only for the weekend. There are costs to not loving what we do.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("There’s the drain on our energy – working somewhere we don’t want to be exhausts and drains us even more than working more hours doing something we love.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("There’s the drain on our emotional health – we choose to numb down our dissatisfaction by doing other things, such as Netflix and wine. Chocolate cake. Exercising too much. Sex. Retail therapy. Facebook. Pinterest. Housework. Projects or hobbies we take on but don’t really love. And so on.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Refusing to feel how stressed and unhappy we are affects our health and wellness. We end up getting sick more often. Feeling more run down. Having extra headaches, soreness, weird lingering pain from injuries. We end up feeling like there’s a big ol’ heap of "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("blah")]), _vm._v(" and "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("meh")]), _vm._v(" blanketing our lives.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("There’s a drain in our ability to be happy and present moms – we find that weekends are the only time we get to be with our families without feeling too tired and cranky to deal with them.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("When we really want to do something but we’re not letting ourselves explore the options, we take up valuable thinking space – which is draining. We’ve "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("thought")]), _vm._v(" ourselves into a giant tangled mess of “when that happens” …. “but not until that happens” …. “which can’t happen until that other thing happens.” And, so far, even though our minds have been up at night going over it and over it, we haven’t been able to think up a solution.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("What we’re doing is looking for permission to do something wonderful for ourselves – even if it’s terrifying and we’re pretty sure we would fail. The good news is that this book is that permission.")]), _vm._v(" "), _c('p', {
    staticClass: "star"
  }, [_vm._v("* * *")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Frazzled to Free")]), _vm._v(" outlines a framework of tools to help you get from where you are now to living the vision of Soul freedom that you desperately want and need. The journey includes learning how to tackle those fears.")]), _vm._v(" "), _c('p', {
    staticClass: "listt"
  }, [_c('span', {
    staticClass: "lno"
  }, [_vm._v("•")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/xhtml/chap01"
    }
  }, [_vm._v("Chapter 1 – My Story")]), _vm._v(". See how I used the framework to gain freedom.")]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_c('span', {
    staticClass: "lno"
  }, [_vm._v("•")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/chap02",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 2 – Your Shiny New Toolkit")]), _vm._v(". Discover the tools that will get you there.")]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_c('span', {
    staticClass: "lno"
  }, [_vm._v("•")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/chap03",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 3 – Soul-Care")]), _vm._v(". Learn how to care for yourself during the transition.")]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_c('span', {
    staticClass: "lno"
  }, [_vm._v("•")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/chap04",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 4 – Find Your Gifts")]), _vm._v(". Relearn who you are now that you’re a momma")]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_c('span', {
    staticClass: "lno"
  }, [_vm._v("•")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/chap05",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 5 – Divine Discontent")]), _vm._v(". Clarify what you don’t want.")]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_c('span', {
    staticClass: "lno"
  }, [_vm._v("•")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/chap06",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 6 – Dream That Dream")]), _vm._v(". Envision your career and what you want to do next.")]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_c('span', {
    staticClass: "lno"
  }, [_vm._v("•")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/chap07",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 7 – Declare It")]), _vm._v(". Clearly state your intentions")]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_c('span', {
    staticClass: "lno"
  }, [_vm._v("•")]), _c('span', {
    attrs: {
      "href": "#/xhtml/chap08",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 8 – Pull It Off")]), _vm._v(". Discover how to get it done.")]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_c('span', {
    staticClass: "lno"
  }, [_vm._v("•")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/chap09",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 9 – The Obstacles")]), _vm._v(". The stuff gets in the way and how to get around it.")]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_c('span', {
    staticClass: "lno"
  }, [_vm._v("•")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/chap10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 10 – The Plan")]), _vm._v(". Putting it all together.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-top"
  }, [_vm._v("You’ll learn how to go from where you are right now to where you want to be: a fiercely happy momma with a shiny new career that makes your Soul sing and gives you the time you want with your family.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4161f932","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/fm02.vue
// module id = 75
// module chunks = 0